module.exports = __webpack_public_path__ + "static/media/ios-exit.9571a439.svg";